module.exports = __webpack_public_path__ + "img/workvx.67b1ae8f.png";